import { type FC } from 'react';
import { Box, Typography } from '@mui/material';

import { Scrollbar } from 'components';
import { Formatter } from 'utils';

import { sx } from './styles';
import { type StorageDetails } from '../../types/__generated__/types';

interface DocumentListType {
  files: StorageDetails[];
  selectedFileIndex: number;
  onSelect: (fileIndex: number) => void;
}

export const DocumentList: FC<DocumentListType> = ({
  files,
  selectedFileIndex,
  onSelect,
}) => {
  return (
    <Box>
      <Scrollbar>
        <Box sx={sx.listWrapper}>
          {files.map((file, index) => (
            <Box
              key={file.id}
              onClick={() => {
                onSelect(index);
              }}
              sx={[
                ...(Array.isArray(sx.listItem) ? sx.listItem : [sx.listItem]),
                (t) => ({
                  ...(selectedFileIndex === index && {
                    backgroundColor: t.palette.background.paper,
                  }),
                }),
              ]}
            >
              <Typography sx={sx.nameText}>{file.name}</Typography>
              <Typography variant="12_16_600" sx={sx.dateText}>
                {Formatter.dateFormat({
                  date: file.date,
                  from: 'Base',
                  to: 'DateSlashed',
                })}
              </Typography>
            </Box>
          ))}
        </Box>
      </Scrollbar>
    </Box>
  );
};
